/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "../sass/app.scss"; // メインCSS

const setSlider = () => {
  const scopes = document.querySelectorAll(".js-slider-scope");
  if (scopes.length === 0) return;

  scopes.forEach((scope) => {
    const paginantionElm = scope.querySelector(".swiper-pagination");
    const swiperElm = scope.querySelector(".swiper");

    if (paginantionElm && swiperElm) {
      const sliderImages = [];
      const Images = scope.querySelectorAll(".swiper-wrapper img");
      Images.forEach((img) => sliderImages.push(img.src));

      const swiper = new Swiper(swiperElm, {
        modules: [Pagination],
        pagination: {
          el: paginantionElm,
          type: "bullets",
          clickable: true,
          renderBullet: (index, className) => `<div class="${className}" style="background-image: url(${sliderImages[index]});"></div>`,
        },
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  setSlider();
});
